import SavedReportList, { SavedReportListProps } from 'common/pages/saved-report/SavedReportList.tsx'

export const SavedReportListAdmin = (props: SavedReportListProps) => <SavedReportList {...props} />
